import React from 'react';
import {TypeImplementation} from '@packages/systems/wfdl';
import {RiveSettingsOptions} from '@packages/systems/ui/shared-ui/Rive';
import {
  ContextualExpressions,
  stripAnn,
} from '@packages/utilities/contextual-expression';
import {useRiveContext} from './RiveContext';
import {getString} from '@packages/utilities/json';

export const stateMachine = TypeImplementation.Custom({
  render: function StateMachineInput({expr}) {
    const {stateMachines, selectStateMachine, isInstanceReady} =
      useRiveContext();

    const literal = ContextualExpressions.getLiteral(stripAnn(expr));
    const state = literal ? getString(literal.value) : undefined;
    const validState = state && stateMachines.find(({name}) => name === state);

    return (
      <RiveSettingsOptions
        id="rive-statemachine-input"
        label="State machine"
        onChange={selectStateMachine}
        value={
          isInstanceReady ? (validState ? validState.name : '') : (state ?? '')
        }
        isDisabled={!isInstanceReady}
        options={
          !isInstanceReady && state
            ? [{label: state, value: state}]
            : stateMachines.map(({name}) => ({
                label: name,
                value: name,
              }))
        }
      />
    );
  },
  system: {
    labelVariant: 'hidden',
    defaultValue: null,
  },
});
